// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    // init Swiper:
    const swiper = new Swiper('.default-swiper', {
        modules: [Navigation, A11y],
        loop: false,
        speed: 300,
        spaceBetween: 24,
        slidesPerView: 1.2,
        breakpoints: {
            992: {
                slidesPerView: 2.8,
            },
            768: {
                slidesPerView: 2.2,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        a11y: {
            prevSlideMessage: 'Ga naar vorige slide',
            nextSlideMessage: 'Ga naar volgende slide',
        },
    });
});
